module.exports = __webpack_public_path__ + "static/media/mobile.e062ecba.svg";